import React from 'react';
import TallyEmbed from '../components/TallyEmbed';

const JoinTheTeam = () => (
  <div className="min-h-screen bg-cream" data-testid="join-the-team-page">
    {/* Hero Section */}
    <section className="bg-cream pt-28 sm:pt-32 md:pt-36 pb-12 md:pb-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-5">
          <span className="text-dark-green/40">&rarr;</span> Dharma Initiative &middot; Team
        </p>
        <h1 className="font-serif text-4xl sm:text-5xl md:text-7xl lg:text-8xl leading-tight tracking-tight mb-8 max-w-6xl">
          <span className="text-gradient-hero">Join the team.</span>
          <br />
          <span className="text-gradient-hero-light italic">Shape what's next.</span>
        </h1>
        <p className="text-dark-green/75 text-lg sm:text-xl md:text-2xl leading-snug max-w-3xl">
          We're expanding - fast! Join our various teams that are shaping our future.
        </p>
      </div>
    </section>

    {/* Form Section */}
    <section className="bg-cream py-14 sm:py-18 md:py-22 px-4 sm:px-6 border-t border-dark-green/10">
      <div className="max-w-3xl mx-auto">
        <div className="mb-10 md:mb-12">
          <p className="text-dark-green/60 font-mono tracking-[0.25em] text-xs sm:text-sm uppercase mb-3">
            <span className="text-dark-green/40">&rarr;</span> 01 / For
          </p>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-dark-green leading-tight max-w-3xl">
            Driven individuals who want to make an impact.
          </h2>
        </div>
        <TallyEmbed formId="ODj0lR" title="Join the Team Application Form" />
      </div>
    </section>
  </div>
);

export default JoinTheTeam;
